"use client";

import { SvgNameMap, type SvgNameType } from "./richColorSvgs/types";

import { Icon } from "./IconFont";
import OspSvgIcon from "./OspSvgIcon";
import type iconFontConfig from "./fonts/Ospicons.json";

export interface IconProps {
  name: keyof typeof iconFontConfig | SvgNameType | string;
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  "data-tracking-scope"?: string;
}

export function OspIcons(props: IconProps) {
  if (SvgNameMap[props.name as SvgNameType]) {
    return <OspSvgIcon {...props} />;
  }
  return <Icon {...props} />;
}
